export const ROUTES_PUBLIC = {
    base: "/",
    usuarios: "/usuarios",
    comunicados: "/comunicados",
    grupos_interes: "/grupos-interes",
    guias_comerciales: "/guias-comerciales",
    incidencias: "/incidencias",
    encuestas: "/encuestas",
    reservas: "/reservas",
    pedidos: "/pedidos",
    redes_informacion: "/redes-informacion",
    agenda: "/agenda",
    noticias: "/noticias",
};